import { useSelector } from "react-redux"
import { Navigate } from 'react-router-dom';
import SplashScreen from "../SplashScreen"
const ProtectedRoute = ({ component: Component }) => {
    const isLoggedIn = useSelector(state => state.AuthReducer.isLoggedIn)

    return (
        <>
            {

                isLoggedIn === null
                    ?
                    <SplashScreen />
                    :
                    !isLoggedIn
                        ?
                        <Navigate to="/login" />
                        :
                        <Component />
            }
        </>
    )
}

export default ProtectedRoute;
